import { render, staticRenderFns } from "./AdsComponents.vue?vue&type=template&id=44bdf661&scoped=true"
import script from "./AdsComponents.vue?vue&type=script&lang=js"
export * from "./AdsComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bdf661",
  null
  
)

export default component.exports